import { DefaultTheme } from '@react-navigation/native'
import { baseTheme } from './baseTheme'

export const darkTheme = {
  dark: true,
  colors: {
    ...DefaultTheme.colors,
    primary: '#5598D2',
    secondary: '#444444',
    black: '#070B2D',
    error: '#EA504F',
    white: '#ffffff',
    background: '#ffffff',
    green: '#7FC95C',
    orange: '#FFA726',
    yellow: '#FFEB3B',
    grey: '#E4E4E4',
    greyBlue: '#78849E',
    gold: '#D39E50',
    lightGrey: '#44444473',
    grey05: '#44444405',
    grey10: '#44444410',
    grey20: '#44444420',
    grey30: '#4c444444',
    grey50: '#80444444',
    pink: '#FF69B4',
    sidebar: 'rgb(243,250,255)',
    // Events POC
    linkedin: '#378FE9',
    pageBackground: '#F5F8FC',
    errorSoft: '#FDECEC',
    successSoft: '#EEF7EA',
  },
  ...baseTheme,
}
